module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [(_vm.process === 'step_1') ? [_vm._v("\n\t\t\t\t\t\tEdit Contest Prizes\n\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.activePrize.id ? 'Edit' : 'Create New') + " Contest Prize\n\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? [_vm._v("\n\t\t\t\t\t\tCreate New Contest Rule\n\t\t\t\t\t")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.process === 'step_1') ? _c('div', {
    key: "step_1"
  }, [_c('button', {
    staticClass: "btn blue btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.throttledCreate()
      }
    }
  }, [_vm._v("Create a New Prize")]), _vm._v(" "), _c('div', {
    staticClass: "prize-progress"
  }, [_vm._l((_vm.prizes), function(prize) {
    return [_c('div', {
      staticClass: "clickable",
      style: ({
        backgroundColor: prize.color,
        width: ((prize.weight) + "%"),
        padding: ("2px " + ((prize.weight >= 2) ? '5px' : '0'))
      }),
      on: {
        "mouseover": function($event) {
          _vm.selectPrize(prize)
        }
      }
    }, [_vm._v(_vm._s((prize.weight >= 4) ? ((prize.weight) + "%") : ''))])]
  })], 2), _vm._v(" "), (_vm.prizes.length && _vm.currentCoverage < 100) ? _c('i', {
    staticClass: "font-red-thunderbird"
  }, [_c('small', [_vm._v("* Note that 100% prize coverage is required to run your campaign.")])]) : _vm._e(), _vm._v(" "), (_vm.activePrize.id) ? _c('div', {
    staticClass: "portlet box blue-hoki margin-top-20",
    style: ({
      border: ("1px solid " + (_vm.activePrize.color))
    })
  }, [_c('div', {
    staticClass: "portlet-title",
    style: ({
      backgroundColor: _vm.activePrize.color
    })
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.activePrize.name) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', [_c('img', {
    staticClass: "active-prize-image",
    attrs: {
      "src": _vm.activePrize.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [_c('ul', {
    staticStyle: {
      "listStyleType": "none",
      "paddingLeft": "0"
    }
  }, [_c('li', [_c('b', [_vm._v("Quantity: ")]), _vm._v(_vm._s((_vm.activePrize.quantity === 0) ? 'Unlimited' : _vm.activePrize.quantity) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Odds of Winning: ")]), _vm._v(_vm._s(_vm.activePrize.weight) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Claim Type: ")]), _vm._v(_vm._s(_vm.activePrize.claim_type) + "\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('button', {
    staticClass: "btn blue btn-sm margin-top-20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editPrize(_vm.activePrize)
      }
    }
  }, [_vm._v("Edit Prize")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue btn-sm margin-top-20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addRule()
      }
    }
  }, [_vm._v("Add Prize Rule")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue btn-sm margin-top-20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.viewRules(_vm.activePrize)
      }
    }
  }, [_vm._v("View Prize Rules")])])])]) : _vm._e(), _vm._v(" "), (!_vm.prizes.length) ? _c('div', {
    staticClass: "center margin-top-20 font-grey-cascade"
  }, [_c('i', [_vm._v("No prizes created yet.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
    key: "step_2"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createContestPrize($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPrize.name),
      expression: "newPrize.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrize.name.length
    },
    attrs: {
      "type": "text",
      "id": "new_prize_name",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.newPrize.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrize, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_prize_name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("This is the name of the prize that will be displayed to the user.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPrize.image),
      expression: "newPrize.image",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrize.image.length
    },
    attrs: {
      "type": "text",
      "id": "new_prize_image",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.newPrize.image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrize, "image", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_prize_image"
    }
  }, [_vm._v("Image")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("This is the image of the prize that will be displayed to the user.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPrize.quantity),
      expression: "newPrize.quantity",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrize.quantity || _vm.newPrize.quantity === 0
    },
    attrs: {
      "type": "number",
      "id": "new_prize_quantity",
      "maxlength": "255",
      "disabled": _vm.newPrize.unlimited_quantity
    },
    domProps: {
      "value": (_vm.newPrize.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrize, "quantity", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_prize_quantity"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The total quantity of this prize that will be available.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-md-checkboxes margin-bottom-20"
  }, [_c('div', {
    staticClass: "md-checkbox-inline"
  }, [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPrize.unlimited_quantity),
      expression: "newPrize.unlimited_quantity"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "checkbox-no-age-limit"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPrize.unlimited_quantity) ? _vm._i(_vm.newPrize.unlimited_quantity, null) > -1 : (_vm.newPrize.unlimited_quantity)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPrize.unlimited_quantity,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPrize.unlimited_quantity = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newPrize.unlimited_quantity = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newPrize, "unlimited_quantity", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-no-age-limit"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n\t            \t\t\t\t\t\t\tUnlimited Quantity\n\t            \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
    attrs: {
      "content": 'Enabling this will set the limit of this prize to unlimited.'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPrize.weight),
      expression: "newPrize.weight",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrize.weight > 0
    },
    attrs: {
      "type": "number",
      "id": "new_prize_weight",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.newPrize.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrize, "weight", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_prize_weight"
    }
  }, [_vm._v("Odds of Winning (%)")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("This value represents the odds (out of 100) that a user has of winning this prize.")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tClaim Type\n\t\t\t\t\t\t\t\t\t"), _c('info-popover', {
    attrs: {
      "content": 'Select `none` if this is a prize that cannot be claimed.'
    }
  })], 1), _vm._v(" "), _c('dropdown', [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown"
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.newPrize.claim_type || 'Select a Claim Type') + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setClaimType('none')
      }
    }
  }, [_vm._v("none")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setClaimType('text')
      }
    }
  }, [_vm._v("text")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setClaimType('href')
      }
    }
  }, [_vm._v("href")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setClaimType('post_request')
      }
    }
  }, [_vm._v("post_request")])])])])], 1), _vm._v(" "), (_vm.newPrize.claim_type.length && _vm.newPrize.claim_type !== 'none') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPrize.claim),
      expression: "newPrize.claim",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrize.claim.length
    },
    attrs: {
      "type": "text",
      "id": "new_prize_claim"
    },
    domProps: {
      "value": (_vm.newPrize.claim)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrize, "claim", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_prize_claim"
    }
  }, [(_vm.newPrize.claim_type === 'text') ? [_vm._v("\n\t                            \t\tClaim Text\n\t                            \t")] : _vm._e(), _vm._v(" "), (_vm.newPrize.claim_type === 'href') ? [_vm._v("\n\t                            \t\tClaim Link\n\t                            \t")] : _vm._e(), _vm._v(" "), (_vm.newPrize.claim_type === 'post_request') ? [_vm._v("\n\t                            \t\tClaim Post Request\n\t                            \t")] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.newPrize.claim_type.length && _vm.newPrize.claim_type === 'post_request') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPrize.claim_post_request_params),
      expression: "newPrize.claim_post_request_params",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrize.claim_post_request_params.length
    },
    attrs: {
      "type": "text",
      "id": "new_prize_claim"
    },
    domProps: {
      "value": (_vm.newPrize.claim_post_request_params)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrize, "claim_post_request_params", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_prize_claim"
    }
  }, [_vm._v("\n\t                            \tPost Request Claim Type\n\t                            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-20"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "add-contest-rules-submit",
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? _c('div', {
    key: "step_3"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createPrizeRule($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Starts At")]), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "format": "h:mm A",
      "editable": false,
      "placeholder": "Select Start Time"
    },
    model: {
      value: (_vm.newRule.starts_at),
      callback: function($$v) {
        _vm.$set(_vm.newRule, "starts_at", $$v)
      },
      expression: "newRule.starts_at"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Ends At")]), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "format": "h:mm A",
      "editable": false,
      "placeholder": "Select End Time"
    },
    model: {
      value: (_vm.newRule.ends_at),
      callback: function($$v) {
        _vm.$set(_vm.newRule, "ends_at", $$v)
      },
      expression: "newRule.ends_at"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-md-checkboxes margin-bottom-20"
  }, [_c('div', {
    staticClass: "md-checkbox-inline"
  }, [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRule.specific_day),
      expression: "newRule.specific_day"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "checkbox-specific-day",
      "disabled": _vm.process !== 'step_3'
    },
    domProps: {
      "checked": Array.isArray(_vm.newRule.specific_day) ? _vm._i(_vm.newRule.specific_day, null) > -1 : (_vm.newRule.specific_day)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newRule.specific_day,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newRule.specific_day = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newRule.specific_day = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newRule, "specific_day", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-specific-day"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n                \t\t\t\t\t\t\tOnly on specific day\n                \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
    attrs: {
      "content": 'By enabling this, the promotional odds will only run on one specific day.'
    }
  })], 1)])]), _vm._v(" "), (_vm.newRule.specific_day) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Date")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "format": 'MMM dd, yyyy',
      "type": "date",
      "editable": false,
      "placeholder": "Select Date"
    },
    model: {
      value: (_vm.newRule.date),
      callback: function($$v) {
        _vm.$set(_vm.newRule, "date", $$v)
      },
      expression: "newRule.date"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRule.max_redemptions),
      expression: "newRule.max_redemptions"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newRule.max_redemptions >= 0
    },
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.newRule.max_redemptions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRule, "max_redemptions", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Max Redemptions")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The maximum redemptions that will be available for this prize. Use ‘0’ if unlimited.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRule.weight),
      expression: "newRule.weight"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newRule.weight > 0
    },
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.newRule.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRule, "weight", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Odds of Winning (%)")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("This value represents the odds (out of 100) that a user has of winning this prize.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-20"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "edit-contest-prize-submit",
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])])]) : _vm._e()])], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f80e7e70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UNOgames/EditContestPrizes.vue
// module id = 462
// module chunks = 1